import {DATE_TIME_FORMAT} from "../constants";
import moment from "moment";
import React from "react";
import {Button, Table} from "reactstrap";

export function parseDate(dateVal) {
    if(dateVal == null || !moment(dateVal).isValid())
        return "Fecha inválida";
    return moment(dateVal).format(DATE_TIME_FORMAT);
}

export function calculateTimeDiff(startDate,endDate) {
    if(startDate == null || endDate == null || !moment(startDate).isValid() || !moment(endDate).isValid())
        return "Cálculo inválido";
    return moment(endDate).diff(moment(startDate),'seconds');
}

export function displayTimeDiff(startDate,endDate) {
    let result = calculateTimeDiff(startDate,endDate);
    if(result === "Calculo inválido")
        return result;
    return result + " segs.";
}

export function formatFloatString(floatValue) {
    console.log("About to format " + floatValue);
    if(floatValue == null)
        return "N/A";
    let stringValue = floatValue.toString();
    let result = stringValue.replace(/[^0-9.,]/g, '');
    if (/[,.]\d+$/.test(stringValue)) {
        console.log("Result was: " + result);
        result = result.replace(/\.(\d{1,2})\d*$/, ',$1');
        console.log("Result after parse: " + result);
    }
    else {
        console.log("Didn't enter parse");
    }
    return result;
}

export function countOrInteractiveHeaderBasedOnFunction(func,elementsLabel) {
    return <th className="text-center">{func == null ? "Total " + elementsLabel : "Ver " + elementsLabel}</th>;
}

export function countOrInteractiveButtonBasedOnFunction(func,data,elementsLabel,elementsCount) {
    if(func == null){
        return <td className="text-center">{elementsCount}</td>
    }
    return <td className="text-center">
        <Button
            className="mb-2 mr-2"
            color="warning"
            onClick={() => func(data)}
        >
            Ver {elementsLabel}
            <span className="badge badge-danger">{elementsCount}</span>
        </Button>
    </td>
}

function getCSVWords(words,isCorrect) {
    if(words == null || words.length === 0){
        return "No se registraron";
    }
    let filteredWords = words.filter(w => w.esCorrecta === (isCorrect ? "S" : "N"));
    return filteredWords.length === 0 ? "No se registraron" : filteredWords.map(w => w.palabra).join(", ");
}

export function getCSVInstitutions(institutions) {
    if(institutions == null || institutions.length === 0){
        return "No posee";
    }
    return institutions.map(i => i.nombre).join("; ");
}

export function getCSVCorrectWords(words) {
    return getCSVWords(words,true);
}

export function getCSVIncorrectWords(words) {
    return getCSVWords(words,false);
}

export function renderActivityListMiniJuegos(minijuegos,prevPageButtonOnClick,nextPageButtonOnClick,pageLink) {
    return (
        <Table hover className="mb-0">
            <thead>
            <tr>
                <th className="text-center">ID Mini Juego</th>
                <th className="text-center">Nombre</th>
                <th className="text-center">Tipo Mini Juego</th>

                <th className="text-center">Puntaje</th>
                <th className="text-center">Estrellas</th>


                <th className="text-center">Terminado</th>
                <th className="text-center">Fecha Inicio</th>
                <th className="text-center">Fecha Termino</th>
                <th className="text-center">Tiempo en completar</th>


            </tr>
            </thead>
            <tbody>
            {minijuegos.map((e) => {
                return (
                    <tr key={e.id}>
                        <td className="text-center">{e.minijuego.id}</td>
                        <td className="text-center">{e.minijuego.nombre}</td>
                        <td className="text-center">{e.minijuego.tipoMinijuegoEntity.descripcion}</td>

                        <td className="text-center">{e.puntaje}/100</td>
                        <td className="text-center">{e.estrellas}</td>
                        <td className="text-center">{e.terminado}</td>
                        <td className="text-center">{parseDate(e.tiempoComienzo)}</td>
                        <td className="text-center">{parseDate(e.tiempoFin)}</td>
                        <td className="text-center">{displayTimeDiff(e.tiempoComienzo,e.tiempoFin)}</td>



                    </tr>
                );
            })}
            <div>
                <nav
                    aria-label="Page"
                    className="d-flex w-100 justify-content-center  "
                >
                    <ul className="pagination">
                        <li
                            className="page-item"
                            onClick={() => prevPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Previous">
                                <span aria-hidden="true">«</span>
                                <span className="sr-only"> Pagina Anterior</span>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link">{pageLink}</a>
                        </li>
                        <li
                            className="page-item"
                            onClick={() => nextPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Next">
                                <span aria-hidden="true">»</span>
                                <span className="sr-only">Proxima Pagina</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            </tbody>
        </Table>
    );
}

export function renderActivityListHistoriasLeidas(historias,prevPageButtonOnClick,nextPageButtonOnClick,pageLink) {
    return (
        <Table hover className="mb-0">
            <thead>
            <tr>
                <th className="text-center">ID Historia</th>
                <th className="text-center">Descripción Historia</th>
                <th className="text-center">Descripción Planeta </th>
                <th className="text-center">Fecha Inicio</th>
                <th className="text-center">Fecha Termino</th>
                <th className="text-center">Tiempo en completar</th>

            </tr>
            </thead>
            <tbody>
            {historias.map((e) => {
                return (
                    <tr key={e.id}>
                        <td className="text-center">{e.historia.id}</td>
                        <td className="text-center">{e.historia.descripcion}</td>
                        <td className="text-center">{e.historia.planeta.descripcion}</td>

                        <td className="text-center">{parseDate(e.tiempoComienzo)}</td>
                        <td className="text-center">{parseDate(e.tiempoFin)}</td>
                        <td className="text-center">{displayTimeDiff(e.tiempoComienzo,e.tiempoFin)}</td>


                    </tr>
                );
            })}
            <div>
                <nav
                    aria-label="Page"
                    className="d-flex w-100 justify-content-center  "
                >
                    <ul className="pagination">
                        <li
                            className="page-item"
                            onClick={() => prevPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Previous">
                                <span aria-hidden="true">«</span>
                                <span className="sr-only"> Pagina Anterior</span>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link">{pageLink}</a>
                        </li>
                        <li
                            className="page-item"
                            onClick={() => nextPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Next">
                                <span aria-hidden="true">»</span>
                                <span className="sr-only">Proxima Pagina</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            </tbody>
        </Table>
    );
}

export function renderActivityListPlanetas(planetas,prevPageButtonOnClick,nextPageButtonOnClick,pageLink) {
    return (
        <Table hover className="mb-0">
            <thead>
            <tr>
                <th className="text-center">ID Planeta</th>
                <th className="text-center">Descripción Planeta</th>
                <th className="text-center">Orden Planeta </th>
                <th className="text-center">Fecha Actividad</th>



            </tr>
            </thead>
            <tbody>
            {planetas.map((e) => {
                return (
                    <tr key={e.id}>
                        <td className="text-center">{e.planeta.id}</td>
                        <td className="text-center">{e.planeta.descripcion}</td>
                        <td className="text-center">{e.planeta.orden}</td>
                        <td className="text-center">{parseDate(e.horaActividadRealizada)}</td>




                    </tr>
                );
            })}
            <div>
                <nav
                    aria-label="Page"
                    className="d-flex w-100 justify-content-center  "
                >
                    <ul className="pagination">
                        <li
                            className="page-item"
                            onClick={() => prevPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Previous">
                                <span aria-hidden="true">«</span>
                                <span className="sr-only"> Pagina Anterior</span>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link">{pageLink}</a>
                        </li>
                        <li
                            className="page-item"
                            onClick={() => nextPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Next">
                                <span aria-hidden="true">»</span>
                                <span className="sr-only">Proxima Pagina</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            </tbody>
        </Table>
    );
}

export function renderActivityListNiveles(niveles,prevPageButtonOnClick,nextPageButtonOnClick,pageLink) {
    return (
        <Table hover className="mb-0">
            <thead>
            <tr>

                <th className="text-center">Nivel </th>
                <th className="text-center">Puntaje Asteroide </th>
                <th className="text-center">Niveles Ganados Asteroide</th>
                <th className="text-center">Fecha Actividad</th>



            </tr>
            </thead>
            <tbody>
            {niveles.map((e) => {
                return (
                    <tr key={e.id}>

                        <td className="text-center">{e.nivel}</td>
                        <td className="text-center">{e.actividadAsteroideCompletado.puntaje}</td>
                        <td className="text-center">{e.actividadAsteroideCompletado.nivelesGanados}</td>
                        <td className="text-center">{parseDate(e.horaActividadRealizada)}</td>




                    </tr>
                );
            })}
            <div>
                <nav
                    aria-label="Page"
                    className="d-flex w-100 justify-content-center  "
                >
                    <ul className="pagination">
                        <li
                            className="page-item"
                            onClick={() => prevPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Previous">
                                <span aria-hidden="true">«</span>
                                <span className="sr-only"> Pagina Anterior</span>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link">{pageLink}</a>
                        </li>
                        <li
                            className="page-item"
                            onClick={() => nextPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Next">
                                <span aria-hidden="true">»</span>
                                <span className="sr-only">Proxima Pagina</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            </tbody>
        </Table>
    );
}

export function renderActivityListCordonesAsteroides(asteroides,prevPageButtonOnClick,nextPageButtonOnClick,pageLink) {
    return (
        <Table hover className="mb-0">
            <thead>
            <tr>
                <th className="text-center">ID Asteroides</th>
                <th className="text-center">Nivel Asteroide</th>
                <th className="text-center">Palabras correctas</th>
                <th className="text-center">Niveles Ganados</th>
                <th className="text-center">Fecha Inicio</th>
                <th className="text-center">Fecha Termino</th>
                <th className="text-center">Tiempo en completar</th>
                <th className="text-center">Palabras correctas</th>
                <th className="text-center">Palabras incorrectas</th>

            </tr>
            </thead>
            <tbody>
            {asteroides.map((e) => {
                return (
                    <tr key={e.id}>
                        <td className="text-center">{e.cordonAsteroides.id}</td>
                        <td className="text-center">{e.cordonAsteroides.nivel}</td>
                        <td className="text-center">{e.puntaje}/10</td>
                        <td className="text-center">{e.nivelesGanados}</td>
                        <td className="text-center">{parseDate(e.tiempoComienzo)}</td>
                        <td className="text-center">{parseDate(e.tiempoFin)}</td>
                        <td className="text-center">{displayTimeDiff(e.tiempoComienzo,e.tiempoFin)}</td>
                        <td className="text-center">{getCSVCorrectWords(e.actividadAsteroideCompletadoPalabraEntities)}</td>
                        <td className="text-center">{getCSVIncorrectWords(e.actividadAsteroideCompletadoPalabraEntities)}</td>

                    </tr>
                );
            })}
            <div>
                <nav
                    aria-label="Page"
                    className="d-flex w-100 justify-content-center  "
                >
                    <ul className="pagination">
                        <li
                            className="page-item"
                            onClick={() => prevPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Previous">
                                <span aria-hidden="true">«</span>
                                <span className="sr-only"> Pagina Anterior</span>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link">{pageLink}</a>
                        </li>
                        <li
                            className="page-item"
                            onClick={() => nextPageButtonOnClick()}
                        >
                            <a className="page-link" aria-label="Next">
                                <span aria-hidden="true">»</span>
                                <span className="sr-only">Proxima Pagina</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            </tbody>
        </Table>
    );
}


// WEBPACK FOOTER //
// src/utils/helperMethods/index.js